/** @jsx jsx */
import { css, jsx, Theme } from '@emotion/react'
import React, { ReactNode } from 'react'
import { Info as InfoIcon } from '@mui/icons-material'

interface Props {
  children?: ReactNode
}

export function WarningMessage({ children }: Props) {
  return (
    <div
      data-testid="warning-message"
      css={css`
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
      `}
    >
      <InfoIcon
        css={(theme: Theme) => css`
          color: ${theme.custom.palette['blue-231'][48]};
          padding-right: 4px;
        `}
      />
      <p
        css={(theme: Theme) => css`
          color: ${theme.custom.palette.grey['33']};
        `}
      >
        {children}
      </p>
    </div>
  )
}
